import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosInstance from '../../axiosInstance.js';

export const GetDeleteArticleByAPISlice = createAsyncThunk("Delete-Article",async (param, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`listingapiarticles/deleted?${param}`);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);  
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const DeleteArticleSlice = createSlice({
  name: 'Delete Article',
  initialState: {
    AllDeleteArticle: [],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      // toast.error(state.error);
    }

    builder
      .addCase(GetDeleteArticleByAPISlice.pending,handlePendingState)
      .addCase(GetDeleteArticleByAPISlice.fulfilled, (state, action) => {
        state.AllDeleteArticle = action.payload.data?.articles; 
        state.loading = false;
      })
      .addCase(GetDeleteArticleByAPISlice.rejected,handleRejectState);
  },
});


export default DeleteArticleSlice.reducer;
